import axios from "axios";
import { toast } from "react-toastify";

// Função para determinar a baseURL com base no ambiente
const getBaseUrl = () => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // Se estiver em produção (ascsiadv.com.br)
  if (window.location.hostname === "ascsiadv.com.br" || window.location.hostname === "www.ascsiadv.com.br") {
    return "https://www.ascsiadv.com.br/api";
  }

  // Em desenvolvimento local
  return "http://localhost:3000/api";
};

// Configuração base do axios
const api = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 60000, // 60 segundos
  withCredentials: true,
  maxRedirects: 5,
  maxContentLength: 50 * 1024 * 1024, // 50MB
});

// Interceptor para requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Log para debug em desenvolvimento
    if (process.env.NODE_ENV === "development") {
      console.log("Request:", config.url);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para respostas
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Log para debug em desenvolvimento
    if (process.env.NODE_ENV === "development") {
      console.error("Response Error:", error);
    }

    // Se o erro vier do backend com uma mensagem, usa ela
    if (error.response?.data?.message) {
      error.message = error.response.data.message;
    }

    // Tratamento específico para erros de autenticação
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      window.location.href = "/login";
      return Promise.reject(error);
    }

    // Tratamento de mensagens de erro
    let errorMessage = "Erro ao processar sua solicitação";

    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.code === "ECONNABORTED") {
      errorMessage =
        "O servidor está demorando para responder. Por favor, tente novamente em alguns instantes.";
    } else if (!error.response) {
      errorMessage =
        "Não foi possível conectar ao servidor. Verifique sua conexão ou tente novamente mais tarde.";
    } else if (error.response?.status === 500) {
      errorMessage =
        "Erro interno do servidor. Por favor, tente novamente mais tarde.";
    }

    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });

    return Promise.reject(error);
  }
);

export default api;
